// extracted by mini-css-extract-plugin
module.exports = {"label":"Input_label__yyH_f","input":"Input_input__1o6Ly","error":"Input_error__zZH-2","max":"Input_max__HyqIY"};